const financeiroRoutes = [
  {
    path: '/financeiro/monitor-pagar',
    name: 'financeiro.monitorPagar',
    component: () => import('../views/financeiro/MonitorPagar.vue'),
  },
  {
    path: '/financeiro/monitor-receber',
    name: 'financeiro.monitor-receber',
    component: () => import('../views/financeiro/MonitorReceber.vue'),
  },
  {
    path: '/financeiro/configuracao-esitef',
    name: 'financeiroconfiguracao-esitef',
    component: () => import('../views/financeiro/ConfiguracaoTef.vue'),
  },
  {
    path: '/financeiro/monitor-boletos',
    name: '/financeiro.monitorBoletos',
    component: () => import('../views/financeiro/MonitorBoletos.vue'),
  },
  {
    path: '/financeiro/consulta-mensagens-internas',
    name: 'financeiro.consulta-mensagens-internas',
    component: () => import('../views/financeiro/ConsultaMensagensInternas.vue'),
  },
  {
    path: '/financeiro/tipos-receita',
    name: '/financeiro.tiposReceita',
    component: () => import('../views/financeiro/TiposReceita.vue'),
  },
  {
    path: '/financeiro/conciliacao-bancaria',
    name: '/financeiro.conciliacaoBancaria',
    component: () => import('../views/financeiro/ConciliacaoBancaria.vue'),
  },
  {
    path: '/financeiro/ccorrente-local-condicao',
    name: '/financeiro.ContaCorrenteXLocalXCondpag',
    component: () => import('../views/financeiro/ContaCorrenteXLocalXCondpag.vue'),
  },
  {
    path: '/financeiro/dre-modelos',
    name: '/financeiro.DreModelos',
    component: () => import('../views/financeiro/DreModelos.vue'),
  },
  {
    path: '/financeiro/dre',
    name: '/financeiro.Dre',
    component: () => import('../views/financeiro/Dre.vue'),
  },
  {
    path: '/financeiro/score/:recnum?',
    name: '/financeiro.Score',
    component: () => import('../views/financeiro/Score.vue'),
  },
  {
    path: '/financeiro/consulta-score',
    name: '/financeiro.ScoreConsulta',
    component: () => import('../views/financeiro/ScoreConsulta.vue'),
  },
];

export default financeiroRoutes;
